import React from 'react';
import classNames from 'classnames';

class DropDownItem extends React.Component {
  constructor(props) {
    super(props);
    this.callAction = this.callAction.bind(this);
  }

  callAction(e) {
    // Make Selection
    if (this.props.select) {
      this.props.select(this.props.value);
    }
    // Perform Action
    if (this.props.action) {
      this.props.action();
    }
    // Close Menu
    if (this.props.close) {
      this.props.close();
    }
    // If not a url prevent default
    if (!this.props.href) {
      e.preventDefault();
    }
  }

  getItemName() {
    return this.props.children;
  }

  render() {
    const classes = classNames('NewDropDown-item d-f ai-c', {
      'NewDropDown-item--selected': !!this.props.selected,
      'NewDropDown-item--parent': !!this.props.parent,
      'NewDropDown-item--locked c-d jc-sb': this.props.isLocked,
    });

    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
      <li
        ref="item"
        className={classes}
        onClick={this.props.onClick || this.callAction}
        href={this.props.href || '#'}
      >
        {this.props.children}
        {/* TODO: make this conditional even if it's 0 */}
        {this.props.count && (
          <span className="NewDropDown-count">{this.props.count}</span>
        )}
      </li>
    );
  }
}

export default DropDownItem;
